import React from "react";
import BaseMap from "./BaseMap";
import {formatDateTime, YMAPS_API_KEY} from "../assets/constants";

import SalePointsApi from "../api/references/salePoints";
import {SplitCol, SplitLayout} from "@vkontakte/vkui";
import {Placemark, YMaps, Map, ZoomControl, TypeSelector, FullscreenControl} from "@pbe/react-yandex-maps";
import {GlobalStorageApi} from "../api/StorageApi";

import BaseApi from "../api/BaseApi";
import {createPie} from "../assets/RadialDiagrammSVG";

class CitiesMap extends BaseMap {

    getItems = () => {
        this.showSpinner()

        SalePointsApi.getAllCities({
            by_region: this.props.by_region ? 1 : 0,
            date: formatDateTime(this.props.date)
        }).then(response => {
            const {items} = response.data

            if (items) {

                const promises = []

                items.forEach((city, index) => {

                    if (!city.title || city.title == 'null') {
                        delete items[index]
                        return
                    }
                    promises.push((async () => {
                        const cityName = city.title
                        const key = 'mapData_' + cityName
                        let cityData = await GlobalStorageApi.getItem(key)


                        if (!cityData || cityData === 'undefined') {
                            cityData = await BaseApi.get(`/?act=geoCoder&value=${cityName}`)
                            await GlobalStorageApi.setItem(key, JSON.stringify(cityData.data))
                        } else {
                            cityData = JSON.parse(cityData)
                        }

                        if (!cityData || cityData === 'null') return
                        //  console.log(cityData)
                        const coords = cityData.Point.pos.split(' ')
                        city.mapX = coords[0] * 1
                        city.mapY = coords[1] * 1
                        city.coords = coords
                        items[index] = city
                    })())

                })

                Promise.all(promises).then(() => {
                    this.setState({items: items})
                    this.showDoneSpinner()
                    setTimeout(() => this.mapGetBounds(), 500)
                })

            }
        })
    }

    renderPlacemark = (city, index) => {
        const {foundCnt, competitorCnt} = city

        const total = foundCnt + competitorCnt
        const competitorsPercent = Math.round(competitorCnt / total * 100)
        const config = {strokeWidth: 60, radius: 30, start: "0"}

        const pie = createPie([{
                value: 100 - competitorsPercent,
                color: "blue"
            }, {value: competitorsPercent, color: competitorsPercent || total ? "red" : "#dadada"},],
            config)
        const pieHover = createPie([{
                value: 100 - competitorsPercent,
                color: competitorsPercent || total ? "#4d4dfb" : "#e5e2e2"
            }, {value: competitorsPercent, color: competitorsPercent || total ? "#ff7070" : "#e5e2e2"},],
            config)

        const shareBtn = this.getStandsShareBalloonButton(`city-${index}-${city.title}`, city)

        const baloonHtml = `<div>
                                                    <h3>${city.title}</h3>
                                                    <div style="display: flex">
                                                        ${pie ? `<img class="map-avatar" width="100" src="${`data:image/svg+xml;charset=UTF-8,${encodeURIComponent(pie)}`}" />` : ''}
                                                    </div>
                                                    <div style="color: blue">Наши стенды: ${competitorsPercent || total ? 100 - competitorsPercent : 'Не известно'}%</div>
                                                    <div style="color: red">Конкуренты: ${competitorsPercent || total ? competitorsPercent : 'Не известно'}%</div>
                                                    ${shareBtn}
                                                </div>`
        return <Placemark

            key={index}
            geometry={[city.mapY, city.mapX,]}
            options={{
                iconLayout: 'default#image',
                iconImageHref: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(pie)}`,
                iconImage: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(pie)}`,
                iconImageHover: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(pieHover)}`,
                iconImageSize: [70, 70],
                iconImageOffset: [-35, -35],

            }}
            properties={{
                hideIconOnBalloonOpen: false,
                hintContent: city.title,
                balloonContent: baloonHtml,
            }}
            modules={['geoObject.addon.hint', 'geoObject.addon.balloon']}

            onMouseEnter={this.handleMouseEnter}
            onMouseLeave={this.handleMouseLeave}
            baloonClose={(e) => console.log(e)}

        />
    }


    render() {


        return (
            <SplitLayout popout={this.state.popout}>
                <SplitCol>
                    <YMaps query={{
                        load: "package.full",
                        apikey: YMAPS_API_KEY
                    }}>
                        <Map defaultState={{center: [54.7750, 56.0375], zoom: 5, controls: []}}
                             width={"100%"}
                             height={"93vh"}
                             instanceRef={(map) => {
                                 this.mapRef.current = map; // сохраняем ссылку на объект карты
                             }}>
                            {this.state.items.map((city, index) => this.renderPlacemark(city, index))}
                            <ZoomControl options={{float: "left"}}/>
                            <TypeSelector options={{float: "right"}}/>
                            <FullscreenControl/>
                        </Map>
                    </YMaps>
                </SplitCol>
            </SplitLayout>)
    }
}

export default CitiesMap
